import { createSlice } from '@reduxjs/toolkit';

export const knowledgeBasesSlice = createSlice({
  name: 'knowledgeBases',
  initialState: {
    knowledge_bases_list: [],
    knowledge_base: {},
    knowledge_bases_form_dropdown: {
      providers: [],
      services: [],
    },
  },
  reducers: {
    setKnowledgeBasesListRedux: (state, { payload }) => {
      state.knowledge_bases_list = payload.data;
    },
    storeKnowledgeBaseRedux: (state, { payload }) => {
      state.knowledge_base = payload;
    },
    setKnowledgeBasesFormDropdownRedux: (state, { payload }) => {
      state.knowledge_bases_form_dropdown = payload;
    },
  },
});

export const {
  setKnowledgeBasesListRedux,
  storeKnowledgeBaseRedux,
  setKnowledgeBasesFormDropdownRedux,
} = knowledgeBasesSlice.actions;
